import { ContentModal } from 'sma.common/components/modals';
import {removeXssTriggers, randomString} from 'sma.common/utils';

const Alert = require('sma.admin/components/alert');
const Class = require('sma.fs/chide/class');
const Bulk = require('sma.fs/surveys/options').Bulk;
const ToggleField = require('sma.admin/components/forms.js').ToggleField;
const modals = require('sma.common/components/modals');

const TextEditor = require('sma.common/texteditor');

const removeHTMLTags = function (htmlString) {
	if(htmlString) {
		htmlString = htmlString.replace(/\</g,"&lt;");
		htmlString = htmlString.replace(/\>/g,"&gt;");
		htmlString = htmlString.replace(/\"/g,"&quot;");
		return htmlString;
	}
};

const Button = function (config) {
	var config = $.extend({}, Button.defaults, config || {});
	var button, text, el;

	var result = {};

	if (!config.el) {
		button = el = $('<a/>', { href: '#', 'class': config.classes });

		if (config.dropdown) {
			el = $('<span class="dropdown"></span>').appendTo(el);
		}

		if (config.icon) {
			el = $('<span class="icon icon-' + config.icon + '"></span>').appendTo(el);
		}
	} else {
		button = config.el;
	}

	result.el = button;

	result.setDisabled = function (disabled) {
		button.toggleClass('ui-state-disabled', disabled);
	};

	result.getLabelEl = function () {
		var textEl = $(button);
		while (textEl.children().length > 0) {
			textEl = textEl.children().eq(0);
		}
		return textEl
	};
	result.html = function (val) {
		result.getLabelEl().html(val)
	};
	result.text = function (val) {
		result.getLabelEl().text(val)
	};

	if (config.label) {
		result.text(config.label);
	} else if (config.labelHtml) {
		result.html(config.labelHtml);
	}

	if (config.menu) {
		let getMenu = function (button) {
			button = button || result.el;

			let menu = button.data('menu');

			if (!menu) {
				menu = config.menu;

				var el = menu.element || menu.$el;

				if (!el) {
					el = (menu === true) ? button.next() : $(menu);
					menu = new $.Menu({ classes: '', menuClass: config.menuClass, element: el, align: config.align });
				}

				(menu.element || el).on({
					'menushow show.chide-menu': function (e) {
						b = (button.bind) ? button: e.target.closest(button);
						e = $.Event('menushow', {menu: menu, originalTarget: e.target});
						b.trigger(e);
					},
					'menuselect select.chide-menu': function (e) {
						b = (button.bind) ? button: e.target.closest(button);
						e = $.Event('menuselect', {menu: menu, originalTarget: e.target});
						b.trigger(e);
					},
					'menuhide hide.chide-menu': function (e) {
						b = (button.bind) ? button: e.target.closest(button);
						b.removeClass('ui-state-active');
						e = $.Event('menuhide', {menu: menu, originalTarget: e.target});
						b.trigger(e);
					}
				});

				button.data('menu', menu);

				button.bind('remove', function (e) {
					menu.destroy();
				});
			}

			return menu;
		};

		let onClick = function (e) {
			e.preventDefault();

			var b = $(e.target).closest(button);

			if (b.hasClass('ui-state-disabled')) {
				return false;
			}

			var menu = getMenu(b);

			if (b.hasClass('ui-state-active')) {
				menu.hide();
			} else {
				menu.show(b);
				setTimeout(function (){b.addClass('ui-state-active');}, 0);
			}
		};

		if (button.bind) {
			button.bind($.extend({}, {
				click: $.proxy(onClick, button),
				menushow: $.proxy(config.menushow, button),
				menuselect: $.proxy(config.menuselect, button),
				menuhide: $.proxy(config.menuhide, button)
			}));
		} else {
			$(document).off('click', button).on('click', button, onClick);

			if (config.menushow) {
				$(document).off('menushow', button).on('menushow', button, config.menushow);
			}
			if (config.menuselect) {
				$(document).off('menuselect select.chide-menu', button).on('menuselect select.chide-menu', button, config.menuselect);
			}
			if (config.menuhide) {
				$(document).off('menuhide', button).on('menuhide', button, config.menuhide);
			}
		}

		result.getMenu = getMenu;
	} else {
		if (button.bind) {
			$(button).bind($.extend({}, {
				click: config.click
			}));
		} else {
			if (config.click) {
				$(document).off('click', button).on('click', button, config.click);
			}
		}
	}

	return result;
};

// Notify
const Notifier = Class.create({
	classes: 'chide-notifier notifier',

	hideTimeout: null,
	actionTimeout: null,

	shown: false,

	initialize: function () {
		_.bindAll(this, 'setupTimeouts', 'hide', 'setActionHandler');

		this.el = $('<div></div>').addClass(this.classes).appendTo('body');

		this.el.position({
			my: 'center',
			at: 'center',
			of: window,
			offset: '0 0'
		});

		if(this.el.hide) this.el.hide();
	},

	show: function (msg, opts, callback) {
		opts = (opts) ? opts : {};
		this.callback = (callback) ? callback : null;
		if (opts.type === 'error') {
			this.el.empty().append($('<div/>', {'class': 'error', html: msg}));
		}
		else if (opts.type === 'warning') {
			this.el.empty().append($('<div/>', {'class': 'warning', html: msg}));
		}
		else{
			this.el.html(msg);
		}

		if (!this.shown) {
			this.el.stop(true);
		}

		this.shown = true;

		this.el.show().position({
			my: 'center',
			at: 'center',
			of: window,
			offset: '0 0'
		});

		this.el.css('opacity', 0).animate({opacity: '1'}, 350, this.setupTimeouts);
	},

	setupTimeouts: function () {
		var that = this;

		if (this.hideTimeout) {
			clearTimeout(this.hideTimeout);
			clearTimeout(this.actionTimeout);
		}
		this.hideTimeout = setTimeout(this.hide, 5000);
		this.actionTimeout = setTimeout(this.setActionHandler, 800);


		$('body').unbind('.notifier');
		this.el.unbind('.notifier');
	},
	setActionHandler: function () {
		this.el.bind('mousemove.notifier', this.hide);
		$('body').bind('click.notifier keypress.notifier', this.hide);
	},

	hide: function (e) {
		var that = this;

		this.shown = false;

		$('body').unbind('.notifier');

		setTimeout(function (){that.el.fadeOut(300);}, 800);

		if (this.hideTimeout) {
			clearTimeout(this.hideTimeout);
			this.hideTimeout = null;
		}

		if (this.actionTimeout) {
			clearTimeout(this.actionTimeout);
			this.actionTimeout = null;
		}

		if (this.callback) {
			this.callback();
		}
	}
});

const notify = (function () {
	var notifier = function (msg, opts, callback) {
		if (!notifier.instance) {
			notifier.instance = new Notifier();
		}

		notifier.instance.show(msg, opts, callback);
	};

	return notifier;
}());

// Prompter
const Prompter = Class.create({
	dialog: null,

	initialize: function () {

		this.dialog = $('<div/>').dialog({
			title: null,
			dialogClass: 'prompt-box',
			width: 400,
			height: 180,
			modal: true,
			resizable:false
		});
	},

	show: function (msg, opts, result_callback) {
		var that = this;
		var dialog = this.dialog;

		dialog.empty();
		var textbox = $("<input type='text' class='prompt_text_box text' style='width:90%;'>").keyup(function (e){
			if(e.keyCode == 13){
				//pressed enter: submit dialog
				dialog.dialog("close");
				result_callback.apply(this, [textbox.val()]);
			}
		});
		if('default' in opts) {
			$(textbox).val(opts['default']);
		}
		dialog.append(textbox);
		dialog.dialog('option', 'title', msg);
		dialog.dialog('option', 'buttons', [{
			'class': 'icon icon-check',
			'text': gettext('Ok'),
			'click': function () {
				dialog.dialog("close");
				result_callback.apply(this, [textbox.val()]);
			}
		},{
			'class': 'icon icon-cancel',
			'text': gettext('Cancel'),
			'click': function () {
				dialog.dialog("close");
			}
		}]);
		dialog.dialog("open");
		textbox[0].select();
	}
});

const aprompt = (function () {
	var prompter = function (msg, opts, result_callback) {
		if (!prompter.instance) {
			prompter.instance = new Prompter();
		}

		prompter.instance.show(msg, opts, result_callback);
	};

	return prompter;
}());

// Confirmation
const Confirmer = Class.create({
	dialog: null,

	initialize: function () {

		this.dialog = $('<div/>').dialog({
				title: null,
				dialogClass: 'prompt-box',
				width: 400,
				height: 240,
				modal: true,
				resizable:false
			});
	},

	show: function (msg, result_callback)
	{
		var that = this;
		var dialog = this.dialog;

		dialog.empty();
		dialog.dialog('option', 'title', '');
		dialog.html(msg);
		dialog.dialog('option', 'buttons', [{
			'class': 'icon icon-check',
			'text': gettext('Yes'),
			'click': function () {
				dialog.dialog("close");
				result_callback.apply(this, [true]);
			}
		},{
			'class': 'icon icon-cancel',
			'text': gettext('No'),
			'click': function () {
				dialog.dialog("close");
				result_callback.apply(this, [false]);
			}
		}]);

		dialog.dialog('option', 'position', {of: window});

		dialog.dialog("open");
	}
});

const renderSelect = function (choices, blankChoice, multi) {
	var item = $('<select>').attr('multiple', !!multi).addClass('custom-select');

	if (blankChoice) {
		item.append($('<option>', { val: '', html: blankChoice, 'class': 'blank' }));
	}

	$.each(choices, function (i, el) {
		if (el) {
			item.append($('<option>', { val: el[0], html: el[1] }));
		}
	});

	return item;
};

const delayCallback = function (callback, ms) {
	var timer = 0;
	var that, args;
	var func = function () { callback.apply(that, args); };
	return function () {
		that = this;
		args = arguments;
		clearTimeout(timer);
		timer = setTimeout(func, ms);
	};
};

const Value = Class.create({
	value: undefined,
	enabled: true,
	help: undefined,
	label: undefined,
	labelClass: 'inline',
	labelTag: 'strong',
	optionClass: 'opt row',
	fromInfo: undefined,
	defaultBlank: false,
	clearValue: null,

	initialize: function (config) {
		$.extend(this, config);

		this.value = (this.fromInfo) ? this.fromInfo(this.info || this.value) : this.value;
	},

	renderHelp: function () {
		return (this.help) ? '<a href="#" data-toggle="tooltip" class="help" title="' + this.help + '">(?)<\/a>' : '';
	},

	renderLabel: function () {
		let help = this.renderHelp();
		let result = (this.label) ? '<' +
			this.labelTag + ' class="' + this.labelClass + '">' +
			this.label + ' ' + help + '</' + this.labelTag + '>' : '';

		return result;
	},

	render: function () {
		return $('<div></div>', {
			'class': this.optionClass + ' col-sm-12',
			html: ((this.label) ? '<label>' + this.renderLabel() + '</label>' : '')
		});
	},

	get: function () { return this.value; },

	set: function (value) { this.value = value; },

	changed: function (_value) { },
	refresh: function (_e) { }
});

const Single = Class.create(Value, {
	cloneEl: undefined,
	blankChoice: undefined,
	initialValue: undefined,
	choices: [],

	renderChoices: function () {
		return renderSelect(this.choices, this.blankChoice);
	},

	render: function ($super) {
		var that = this;

		var rendered;

		if (this.cloneEl === true) {
			this.constructor.prototype.cloneEl = this.renderChoices();
			rendered = this.cloneEl.clone();
		} else if (typeof (this.cloneEl) === 'function') {
			rendered = this.cloneEl().clone();
		} else {
			rendered = this.renderChoices();
		}

		rendered
			.val((this.value !== undefined) ? this.value : (this.initialValue || ''))
			.attr('disabled', !this.enabled)
			.bind('change', function (e) {
				that.changed(that.value = $(this).val());
			});

		if (this.label) {
			return $super().find('label').append(rendered).end();
		}

		return $super().append(rendered);
	}
});

const Select = Single;

const Checkbox = Class.create(Value, {
	render: function (items) {
		let that = this;
		let managed;
		let rand = randomString(20);

		let toggleField = new ToggleField({element: $('<div class="col-sm-4 sma-js-toggle-field">\
			<input type="checkbox" class="sma-js-slide-toggle-checkbox sma-slide-toggle-checkbox" id="'+rand+'-slide-toggler">\
			<label class="float-sm-right" for="'+rand+'-slide-toggler">rand</label></div>')});

		toggleField.state = !!this.value;
		toggleField.determineState();

		let rendered = $('<div class="opt row"><label class="col-sm-8"><strong class="inline">'+this.label+'</strong></label></div>')
			.append(toggleField.$el)
			.bind('changed', function (e, value) {
				that.value = value;
				that.changed(value);

				toggleField.state = !!this.value;
				toggleField.determineState();

				if (managed) {
					managed.toggle(value);
				}
			});

		setTimeout(function (){
			rendered.find('input[type=checkbox]:eq(0)').attr('disabled', !that.enabled).attr('checked', !!that.value)
				.bind('refresh', function (e) {
					$(this).attr('disabled', !that.enabled).attr('checked', !!that.value);
					rendered.trigger('changed', [!!this.checked]);
				})
				.bind('click', function (e) {
					rendered.trigger('changed', [!!this.checked]);
				}).end();
		}, 0);

		if (items) {
			managed = $('<div class="managed"/>');
			$.each(items, function (i, el) {
				managed.append((el.render) ? el.render() : el);
			});
			rendered.append(managed.toggle(!!this.value));
		}
		this.set = function (value){
			that.value = value;
			rendered.trigger('changed', [!!that.value]);
			return that;
		};
		this.refresh = function (){
			return rendered.find('input').trigger('refresh', [!!that.value]);
		};
		return rendered;
	}
});

const Text = Class.create(Value, {
	languages: undefined,
	translatable: true,
	applyEdit: false,
	inputClass: 'text',
	initialValue: '',
	continuous_change:true,
	blankText: function () {
		return gettext('None');
	},
	fromInfo: function (value) {
		value = this.clearU200D(value);
		return (this.translatable) ? this.languages.objectify(value) : value;
	},

	refresh: function () {
		if (this._input) {
			this._input.val(this.get());
		}
	},

	clearU200D: function (value) {
		if (value === undefined || value == null) {
			return;
		}

		let retValue = value;

		if (typeof(value) == 'string') {
			retValue = value.replace('\u200d', '');
		} else {
			for (let k in value) {
				value[k] = value[k].replace('\u200D', '');
			}

			retValue = value;
		}

		return retValue;
	},

	render: function ($super, index) {
		const that = this;
		let input;

		if (this.applyEdit) {
			this._input = input = this.renderApplyEdit(index);
		} else {
			let handleChange = function (e) {
				if (!input.is(':visible')) {
					return;
				}
				try {
					that.set(that.clearU200D(input.val()));
				} catch (err) {
					// Do nothing
				}

				if (!e) {
					input.val((that.value === undefined || that.get() === '') ? '' : that.get());
				}

				that.changed(that.get());
			};

			this._input = input = $('<input type="text" class="form-control ' + this.inputClass + '" />')
				.val((this.get()) ? this.get() : this.initialValue)
				.bind('change', function () {
					handleChange();
				})
				.bind('keyup blur mouseup', delayCallback(handleChange, 100));

			if (this.size) {
				input.attr('size', this.size);
			}

			this.refresh = function () {
				input.val(this.get());
			};
		}

		if (this.label) {
			return $super().find('label').append(input).end();
		}
		return $super().append(input);
	},

	renderApplyEdit: function (index) {
		const that = this;

		const editDisplay = $('<a>', {
			'class': 'label label-primary identifier',
			href: '#',
			text: (this.get() !== undefined && this.get() !== '') ? this.get() : this.blankText(index)
		}).click(function (e) {
			e.preventDefault();

			const applyHandler = function (_event) {
				let val = input.val();
				if (val == '') {
					val = undefined;
				}
				let old;
				try {
					old = that.get();
					that.set(val);
					that.changed(val, old);
				} catch (err) {
					if (input.val() === '') {
						that.value = '';
					}
					that.changed(val, old);
				}

				if (that.value === undefined || that.get() === '') {
					if (that.clearValue !== null) {
						that.set(that.clearValue);
						that.changed(that.clearValue, '');
						editDisplay.text(that.clearValue);
					} else {
						editDisplay.text(that.blankText(index));
					}
				} else {
					editDisplay.text(that.get());
				}

				edit.before(editDisplay);
				edit.remove();
			};

			const input = $('<input type="text" />')
				.attr('maxlength', '40')
				.css('display','inline')
				.val((that.get() !== undefined) ? that.get() : that.defaultBlank ? that.blankText(index) : '')
				.addClass('text inline short')
				.bind('change blur', applyHandler);

			const edit = $('<span>', { 'class':'' }).append(input);

			$(this).before(edit).detach();

			input.focus();
		});

		return editDisplay;
	},

	set: function (value) {
		if (this.translatable && typeof(value) === 'string') {
			this.value = (this.value === undefined) ? {} : this.value;
			this.value[this.languages.selected()] = value;
		} else {
			this.value = value;
		}

		if (this._input && this._input.val() != this.get()) {
			this._input.val(this.get());
		}
	},

	get: function () {
		if (this.translatable) {
			return this.languages.translate(this.value);
		} else {
			return this.value;
		}
	}
});

const Html = Class.create(Text, {
	labelClass: '',

	dialogOptions: {
		width: 700,
		height: 480,
		bgiframe: true,
		modal: false,
		zIndex: -1,
		resizable: false,
		closeOnEscape: false,
		title: gettext('Visual Editor')
	},

	showHtmlEditor: function () {
		this.editArea = $('<div><textarea class="form-control"></textarea></div>');
		this.textarea = $('textarea', this.editArea);

		this.dialog = new ContentModal(
			this.textarea,
			{
				title: gettext('Visual Editor'),
				destroyOnClose: true,
				buttons: [{
					label: gettext('OK'),
					cls: 'button-default',
					handler: () => {
						if ($.isFunction(this.editor.clean)){
							this.editor.clean()
						}
						this._input.val(this.editor.getContent());
						this.set(this.editor.getContent());
						this.changed(this.editor.getContent());
						this._input.focus();
						this.dialog.hide();
					}
				}]
			}
		);

		this.editor = new TextEditor({
			textarea: this.textarea,
			piping: window.smaPipingOptions || ['all']
		});

		this.editor.setContent(this.get());
		this.dialog.show();
	},

	render: function () {
		const that = this;
		let input;

		let handleChange = function (event) {
			if (!input.is(':visible')) {
				return;
			}
			try {
				let cleanValue = removeXssTriggers(input.val());
				that.set(cleanValue);
			} catch (err) {
				// Do nothing
			}
			if (!event) {
				input.val(((that.value === undefined || that.get()) === '') ? '' : that.get());
			}
			that.changed(that.get());
		};

		this._input = input = $('<textarea>', { 'class': 'form-control ' + this.inputClass });

		input
			.val((this.get()) ? this.get() : this.initialValue)
			.bind('change', function () {
				handleChange();
			})
			.bind('keyup mouseup', handleChange)
			.focus(function () {
				editHtml.show();
			})
			.blur(function () {
				handleChange();
				editHtml.hide(function () {
					if (that.blurred) {
						that.blurred();
					}
				});
			});

		let editHtml = $('<a href="#" class="edit-html">'+ gettext('Open Visual Editor') + '</a>')
			.click(function () {
				that.showHtmlEditor();
				return false;
			})
			.css('display', 'none');

		return Value.prototype.render.call(this).append(input, editHtml);
	}
});

const Number = Class.create(Text, {
	allowBlank: false,
	translatable: false,
	inputClass: 'text short float-sm-right',
	max: null,
	min: null,
	type: 'float',
	set: function (value) {
		var number = ((this.type=='int') ? parseInt : parseFloat)((isNaN(value)) ? this.value:value, 10);
		if (value === undefined || value === '') {
			if (!this.allowBlank) {
				throw new Error();
			} else {
				this.value = undefined;
			}
		} else if (isNaN(number) || number == Infinity) {
			if (!this.allowBlank) {
				throw new Error();
			} else {
				this.value = undefined;
			}
		} else if (this.min != null && number < this.min) {
			new Alert({
				message: gettext('Value is smaller than allowed minimum - Setting to minimum value.'),
				type: 'warning',
			});
			this.value = this.min;
		} else if (this.max != null && number > this.max) {
			new Alert({
				message: gettext('Value is greater than allowed maximum - Setting to maximum value.'),
				type: 'warning',
			});
			this.value = this.max;
		} else {
			this.value = number;
		}
		return this.value;
	}
});

const DateTime = Class.create(Value, {
	translatable: false,
	hasDate: true,
	hasTime: true,
	ampm: true, //Flag to show AM/PM dropdown
	is12: false, //What format is the time currently stored in comes from the server, and is exported, as 24 so default false
	optionClass: 'opt date-time',
	datePicker: undefined,
	changeMonth: false,
	changeYear: false,
	fromInfo: function (info) {
		this.set(info);
		if (this.hasTime && this.ampm) this._24to12(); //Make it 12 if ampm active
		return this.value;
	},

	update: function (toUpdate) {
		if (this.element === undefined) return;
		if (toUpdate === undefined)
			toUpdate = {'date':true,'time':true};
		if (this.hasDate && toUpdate['date']) {
			var date = this.datePicker.datepicker('getDate')
			date && $('span.date-label', this.element).text(date.format("mmm dS, yyyy"));
		}
		if (this.hasTime && toUpdate['time']) {
			$('input.time-hours', this.element).val(this.value.time.hours);
			$('input.time-minutes', this.element).val(this.value.time.minutes);
			$('select.time-ampm', this.element).val(this.value.time.ampm);
		}
	},

	_24to12: function () {
		if (!this.ampm || !this.hasTime || this.is12) return;
		var hours = parseInt(this.value.time.hours,10);
		if (hours >= 12) {
			if (hours > 12) {
				hours -= 12;
			}
			this.value.time.ampm = 'PM';
		} else {
			this.value.time.ampm = 'AM';
			if (hours == 0) hours = 12;
		}
		this.value.time.hours = hours.toString();
		if (this.value.time.hours.length == 1) { this.value.time.hours = "0" + this.value.time.hours }
		if (this.value.time.minutes.length == 1) { this.value.time.minutes = "0" + this.value.time.minutes }
		this.update({'date': false, 'time': true});
		this.is12 = true;
	},

	_12to24: function () {
		if (!this.ampm || !this.hasTime || !this.is12) return;
		var hours = parseInt(this.value.time.hours,10);

		if (this.value.time.ampm == 'AM') {
			if (hours == 12) {
				this.value.time.hours = "00"
			}
		} else {
			if (hours == 12) return;
			hours = hours + 12;
			if (hours >= 24) {
				this.value.time.hours = "23";
				this.value.time.minutes = "59";
			} else
				this.value.time.hours = hours.toString();
		}

		this.is12 = false;
	},

	getJSDate: function (){
		var d = this.datePicker.datepicker('getDate');
		var was12 = this.is12;
		if (this.hasTime && was12) {
			this._12to24();
		}
		var d = new Date(d.getFullYear(), d.getMonth(), d.getDate(), this.value.time.hours, this.value.time.minutes, 0, 0);
		if (was12) {
			this._24to12();
		}
		return d;
	},

	setDate: function (date) {
		if (date === undefined || date.indexOf('-') == -1) return;
		var splitDate = date.split('-');
		this.value['date'] = new Date(parseInt(splitDate[0],10), parseInt(splitDate[1],10), parseInt(splitDate[2],10));
	},

	setTime: function (time) {
		if (time === undefined || time.indexOf(':') == -1) return;
		if (this.value['time'] == undefined) this.value['time'] = {};
		var splitTime = time.split(':');
		splitTime[0] = parseInt(splitTime[0],10).toString();
		splitTime[1] = parseInt(splitTime[1],10).toString();
		if (this.is12 && parseInt(splitTime[0],10) > 12) {
			splitTime[0] = (parseInt(splitTime[0],10)-12).toString();
			if (parseInt(splitTime[0],10) > 12) {
				splitTime[0] = '12';
			}
			this.value['time']['ampm'] = 'PM';
		}
		if (parseInt(splitTime[0],10) < 0) {
			splitTime[0] = -1 * parseInt(splitTime[0],10).toString();
		}
		if (parseInt(splitTime[1],10) < 0) {
			splitTime[1] = -1 * parseInt(splitTime[1],10).toString();
		}
		if (splitTime[0].length == 1) { splitTime[0] = "0" + splitTime[0] }
		if (splitTime[1].length == 1) { splitTime[1] = "0" + splitTime[1] }
		this.value['time']['hours'] = splitTime[0];
		this.value['time']['minutes'] = splitTime[1];
		this.update({date:false,time:true});
	},

	set: function (value) {
		if (!this.value) { this.value = {}; }
		if (value === undefined || !value || typeof(value) != "string" || value.constructor.toString().indexOf('Date')>0) {
			if (this.hasTime) {
				if (value && value.constructor.toString().indexOf('Date')) {
					this.value['time'] = {'hours': value.getHours(), 'minutes': value.getMinutes()};
					this._24to12();
				} else {
					this.value['time'] = {'hours': '12', 'minutes': '00', 'ampm': 'PM'};
				}
				this.is12 = true;
			}
			if (this.hasDate) {
				if (value && value.constructor.toString().indexOf('Date')) {
					this.value['date'] = value;
				} else {
					this.value['date'] = new Date();
				}
			}
		} else {
			if (value.indexOf(' ') > -1) { //Its both a date and a time
				var date = value.split(' ');
				var dateStr = date[0].split('-');//Python stores month 1-12, js stores them 0-11, conversion time

				dateStr[1] = (parseInt(dateStr[1],10)-1).toString();
				this.setDate(dateStr.join('-'));
				this.setTime(date[1]);
			} else //It's just a date or just a time figure which one
				if (value.indexOf(':') > -1) //Its a time
					this.setTime(value);
				else //We've got to assume date here
					this.setDate(value);
			if (value.toLowerCase().indexOf('am') > -1){
				this.is12 = true;
				this.value['time']['ampm'] = 'AM';
			} else if (value.toLowerCase().indexOf('pm') > -1){
				this.is12 = true;
				this.value['time']['ampm'] = 'PM';
			}
		}

	},

	render: function ($super) {
		var that = this;
		this.element = $super();

		if (this.hasDate) {
			var dateLabel = $('<span></span>', {
				'class': 'date-label',
				html: gettext('Please select a date &raquo;')
			});

			var datePicker = $('<input \/>', {
				name: 'date-picker-text'
			}).hide();

			datePicker.datepicker({
				dateFormat: 'yyyy-m-d',
				changeMonth:this.changeMonth,
				changeYear:this.changeYear,
				onSelect: function (dateText) {
					that.setDate($(this).datepicker('getDate').format("yyyy-m-d"));
					$('span.date-label', that.element).text($(this).datepicker('getDate').format("mmm dS, yyyy"));
					datePicker.datepicker('hide');
				},
				beforeShow: function (input, inst) {
					setTimeout(function () {
						var position = $('a.datepicker-button', that.element).offset();
						inst.dpDiv.css('position','absolute');
						inst.dpDiv.css('top', (position.top + $('a.datepicker-button', that.element).height()).toString() + 'px');
						inst.dpDiv.css('left', position.left.toString() + 'px');
					}, 10);
				}
			});

			if (this.value['date']) {
				datePicker.datepicker('setDate', this.value.date);

				dateLabel.html(datePicker.datepicker('getDate').format("mmm dS, yyyy"));
			}

			if (this.datePicker == undefined)
				this.datePicker = datePicker;

			var datePickerImage = $('<a></a>', {
				href: '#',
				title: gettext('Choose a Date'),
				'class': 'datepicker-button',
				click: function (e) {
					e.preventDefault();
					datePicker.datepicker('show');
				}
			}).append(
				$('<img\/>', {
					src: '/media/img/icons/fugue/icons/calendar-blue.png'
				})
			);
			this.element.append(dateLabel)
				.append('&nbsp;')
				.append(datePicker)
				.append(datePickerImage);
		}

		if (this.hasTime) {
			var timeContainer = $('<span><\/span>', {
				"class": 'time-container'
			});

			if (this.hasDate)
				timeContainer.append(' @ ');

			timeContainer.append(
				$('<input \/>', {
					type: 'text',
					name: 'hours',
					'class': 'time-hours',
					change: function () {
						that.setTime($(this).val() + ':' + $('input[name=minutes]',$(this).parent()).val());
						that.update({'date': false, 'time': true});
					},
					val: this.value.time.hours,
					css: {
						width: '20px'
					}
				})
			).append(' : ')
			.append(
				$('<input \/>', {
					type: 'text',
					name: 'minutes',
					'class': 'time-minutes',
					change: function () {
						that.setTime($('input[name=hours]',$(this).parent()).val() + ':' + $(this).val());
						that.update({'date': false, 'time': true});
					},
					val: this.value.time.minutes,
					css: {
						width: '20px'
					}
				})
			);

			if (this.ampm) {
				var ampmSelect = $('<select><\/select>', {
					"class": 'time-ampm',
					change: function () {
						if (that.value['time'])
							that.value.time['ampm'] = $(this).val();
					}
				}).append(
					$('<option><\/option>', {
						val: 'AM',
						text: gettext('AM')
					})
				).append(
					$('<option></option>', {
						val: 'PM',
						text: gettext('PM')
					})
				);
				if (this.value['time'] && this.value['time']['ampm'])
					ampmSelect.val(this.value.time.ampm);
				timeContainer.append(ampmSelect);
			}

			this.element.append(timeContainer);
		}
		this.update();
		return this.element;
	},

	serialize: function () {
		//Format from value dict to: yyyy-mm-dd 00:00:00
		was12 = this.is12;
		if (this.hasTime && was12) this._12to24();
		var timeString = (this.hasTime)? this.value.time.hours + ':' + this.value.time.minutes + ':00' : '00:00:00';
		var date = this.datePicker.datepicker('getDate')
		var dateString = (this.hasDate && date)? date.format('yyyy-mm-dd') : '';
		if (was12) this._24to12();
		return dateString + ((this.hasTime) ? ' ' + timeString : '');
	}
});

const TextList = Class.create(Value, {
	enableExtraction: true,
	hasSubOptions: false,
	textClass: Text,
	tabOffset: 1,
	direction: 'vertical',

	fromInfo: function (value) {
		let items = [];

		if (value && value.length) {
			if (this.extraction) {
				for (var i = 0; i < value.length; i++) {
					if (this.extraction.multiline && this.extraction.multiline == true) {
						value[i].appearance = 'full';
						value[i].rows = this.extraction.rows;
						value[i].cols = this.extraction.cols;
					}
					if (this.extraction.required) {
						value[i].required = this.extraction.required;
					}
					items.push(this.itemFromValue(value[i]));
				}
			} else {
				for (var i = 0; i < value.length; i++) {
					items.push(this.itemFromValue(value[i]));
				}
			}
		}

		if (this.enableExtraction) {
			var Extraction = require('sma.fs/surveys/advanced').Extraction;
			this.extraction = new Extraction(this.field, { value: this.extraction, textlist:this });
		}

		return items;
	},

	length: function () {
		return this.value.length;
	},

	getAt: function (i) {
		return this.value[i].text.get();
	},

	setAt: function (i, value) {
		this.value[i].text.set(value);

		this.itemChanged(i, this.value[i]);

		if (this._rendered && this._rendered.is(':visible')) {
			$('> li > div.option > input.text', this._rendered)
				.eq(i)
				.val(this.getAt(i));
		}
	},

	updateExtracted: function (value, triggerChanged) {
		var choices = [];
		if (value) {
			var that = this;
			_.each(this.extraction.question.getField().getExtractionChoices(), function (el) {
				choices.push(that.itemFromValue({ label: el[1] }));
			});
		that.value = choices;
		this.itemsChanged(choices);
		return choices;
		}
	},

	render: function () {
		var that = this;

		var el = $('<li><div class="option"><a href="#" class="remove">Remove<\/a><input type="text" class="text" /><\/div><\/li>');

		var handleChange = function (e) {
			if (!$(e.target).is(':visible')) {
				return;
			}
			var item = $(e.target).closest('li');
			var index = rendered.find('> li').index(item);
			var val = $(e.target).val();

			if (index >= 0) {
				that.value[index].text.set(val);
				that.itemChanged(index, that.value[index]);
				if (e.type === 'keyup')
					that.itemsChanged(that);
			}
		};

		var rendered = (this._rendered = $('<ul>', { 'class': 'text-list' })
			.delegate('li > div.option > input.text', 'change', handleChange)
			/*.delegate('li > div.option > input.text', 'focus', function (e) {
				e.target.select();
			})*/
			.delegate('li > div.option > input.text', 'mouseup', function (e) {
				// fix autoselection in Chrome
				e.preventDefault();
			})
			.delegate('li > div.option > input.text', 'keyup blur mouseup', delayCallback(handleChange, 100))
			.delegate('li > div.option > a.remove', 'click', function (e) {

				e.preventDefault();

				if (that.value.length <= 1) {
					return;
				}

				var item = $(this).closest('li');
				var index = rendered.find('> li').index(item);

				const editor = require('sma.fs/surveys/editor').Editor.instances[0];

				if (index >= 0 && editor && editor.form_is_live) {
					const modalTitle = gettext('Change form field');
					const modalBody = that.getChoiceChangeModalBody(true);
					new modals.Confirm(
						modalTitle, modalBody,
						() => {
							item.remove();
							that.value.splice(index, 1);
							that.itemRemoved(index);
							that.itemsChanged(that);
						}, {
							destroyOnClose: true,
							yes: gettext("Make Change"),
							no: gettext("Cancel"),
							yes_class: "btn-danger",
							no_class: "btn-white"
						}
					);
				}
				else if (index >= 0) {
					item.remove();
					that.value.splice(index, 1);
					that.itemRemoved(index);
					that.itemsChanged(that);
				}
			}));


		if (this.hasSubOptions) {
			rendered.delegate('li > div.option > input.text', 'focus', function (e) {
				var item = $(this).closest('li');
				var index = rendered.find('> li').index(item);

				if (index >= 0) {
					var sub = item.find('.suboptions');
					if (!sub.length) {
						sub = that.renderSubOptions(that.value[index], index).appendTo(item);
					}

					$(this).trigger('subOptionsShown', [sub, index, that.value[index]]);

					rendered.find('> li > div.suboptions').not(sub).remove();
					sub.show();
				}
			});
		}

		var refreshForValue = function (value) {
			rendered.empty();

			for (var i = 0; i < value.length; i++) {
				rendered.append(el.clone());
			}

			$('> li > div.option > input.text', rendered).each(function (i, el) {
				$(el).val(value[i].text.get()).attr('tabIndex', that.tabOffset);
			});

			if (that.value !== value) {
				that.value = value;
				that.itemsChanged(value);
			}
		};
		$(rendered).sortable({
			axis: 'y',
			containment: 'parent',
			handle: 'a.move',
			update: function (e, ui) {
				value = [];
				$('> li > div.option > input.text', rendered).each(function (i, el) {
					$.each(that.value,function (index,item) {
						if (item.text.get() == $(el).val()){
							 value.push(item);
							 return false;
						}
					});
				});
				if (that.value !== value) {
					that.value = value;
					that.itemsChanged(value);
				}

			}
		});
		var add = (this._add = function (value) {
			var item = that.addItem(that.itemFromValue(value));

			var clone = el.clone();

			rendered.append(clone);

			$('> div.option > input.text', clone).attr('tabindex', that.tabOffset).val(item.text.get() || '').trigger('focus').focus();

			that.itemsChanged(that);
		});

		refreshForValue(this.value);

		var addButton = $('<a>', { 'class': 'btn btn-secondary btn-sm add', text: gettext('Add'), href: '#' })
			.click(function (e) {
				e.preventDefault();

				const editor = require('sma.fs/surveys/editor').Editor.instances[0];
				if (editor && editor.form_is_live) {
					const modalTitle = gettext('Change form field');
					const modalBody = that.getChoiceChangeModalBody(true);

					new modals.Confirm(
						modalTitle, modalBody,
						() => {
							add();
						}, {
							destroyOnClose: true,
							yes: gettext("Make Change"),
							no: gettext("Cancel"),
							yes_class: "btn-danger",
							no_class: "btn-white"
						}
					);
				} else {
					add();
				}
			});

		var bulkAction = () => {
			Bulk.show(that.direction, (that.value) ? that.value : undefined, function (value) {
				refreshForValue($.map(value, function (el, i) {
					var parsedValues = that.parseBulks(el),
					returnItem;	//returnItem will be our option variable

					if (parsedValues.index !== null) {
						i = parsedValues.index;
					}

					if (that.value[i] && (that.value[i].type == undefined || that.value[i].type.value == parsedValues.type)) {
						that.value[i].text.value = parsedValues['labels'];
						returnItem = that.value[i];
					} else {
						returnItem = that.itemFromValue({ label: el });
					}

					if (!isNaN(parsedValues.score) && returnItem.score && parsedValues.score !== null) {
						returnItem.score.value = parsedValues.score;
					}

					if (parsedValues.type && returnItem.type) {
						var items = _.find( returnItem.type.choices, function (item) {
							return _.contains(item, parsedValues.type);
						});
						if (items) {
							returnItem.type.value = parsedValues.type;
						}
					}
					else if (!parsedValues.type && returnItem.type) {
						returnItem.type.value = 'string';
					}

					if (parsedValues.options) {
						$.each(Bulk.availableOptions, function (i, keyword) {
							if(returnItem[keyword] && parsedValues.options.indexOf(keyword) > -1) {
								returnItem[keyword].value = true;
								if (keyword === 'other_required' && returnItem.other) {
									//automatically set other to true when other_required is true
									returnItem.other.value = true;
								}
							} else if (returnItem[keyword]) {
								returnItem[keyword].value = false;
							}
						});
					}
					return returnItem;
				}));
			});
		};

		var bulkButton = $('<a>', { 'class': 'btn btn-secondary btn-sm bulk', text: gettext('Bulk'), href: '#' })
			.click(function (e) {
				e.preventDefault();

				const editor = require('sma.fs/surveys/editor').Editor.instances[0];

				if (editor && editor.form_is_live) {
					const modalTitle = gettext('Change form field');
					const modalBody = that.getChoiceChangeModalBody(true);

					new modals.Confirm(
						modalTitle, modalBody,
						() => {
							bulkAction();
						}, {
							destroyOnClose: true,
							yes: gettext("Make Change"),
							no: gettext("Cancel"),
							yes_class: "btn-danger",
							no_class: "btn-white"
						}
					);
				} else {
					bulkAction();
				}
			});

		var extraction;

		if (this.enableExtraction) {
			extraction = this.extraction.render();

			$(this.extraction.question).unbind('change.textlist').bind('change.textlist', function (e, value, old) {
				this.value = value;
				if(value) {
					const choices = that.updateExtracted(value);
					refreshForValue(choices);
				}
			});

			var manualButton = $('<a>', { 'class': 'button back', text: gettext('Back to Manual Mode'), href: '#' })
				.click(function (e) {
					e.preventDefault();
					manualButton.hide();
					addButton.show();
					bulkButton.show();
					extractionButton.show();

					extraction.before(rendered).detach();

					that.extraction.question.set('');

					rendered.trigger('extraction', [true]);
				});

			var extractionButton = $('<a>', { 'class': 'btn btn-secondary btn-sm extraction', text: gettext('Extraction'), href: '#' })
				.click(function (e) {
					e.preventDefault();

					manualButton.show();
					addButton.hide();
					bulkButton.hide();
					extractionButton.hide();

					rendered.trigger('extraction', [false]);

					rendered.after(extraction).detach();
				});
		}

		return $('<div>', { 'class': 'clearfix option' }).append(
			(this.enableExtraction && extraction && this.extraction.question.value) ? extraction : rendered,
			addButton.toggle(!this.enableExtraction || !this.extraction.value),
			bulkButton.toggle(!this.enableExtraction || !this.extraction.value),
			(this.enableExtraction) ? extractionButton.toggle(!this.extraction.value) : false,
			(this.enableExtraction) ? manualButton.toggle(!!this.extraction.value) : false);
	},

	getChoiceChangeModalBody: function (form_is_live) {
		if (form_is_live) {
			return '<i class="nc-icon-mini ui-3_alert sma-danger-icon mr-1"></i> ' + gettext('<strong>Warning:</strong> you may lose data by making changes to form fields on a live form. See our help article for more information on <a href="https://help.surveymonkey.com/en/apply/build/change-live-form/" class="sma-underline-blue-link" target="_blank">How to Safely Make Changes to a Live Form</a>.<br><br>This cannot be undone.');
		} else {
			return gettext('Are you sure you want to make changes to this form field?');
		}
	},

	parseBulks : function (input) {
		//input is an object with language codes: {'en': 'This is the english string | 3'}
		var parsed = '',
		type       = null;
		var that   = this,
		score      = null,
		options    = null,
		index      = null;

		$.each(input, function (key, value) {
			var buildOptions = [];
			var match = value.match(/^\[\*A(\d+)\*\]\s*(.*)/);

			if (match) {
				index = parseInt(match[1], 10) - 1;
				value = match[2];
			}

			parsed = $.map(value.split('|'), function (el, i) {
				return el.trim();
			});
			input[key] = parsed.shift();

			match = input[key].match(/\[\[(.*?)\]\]/);
			type = type || (match ? match[1].trim() : '');
			input[key] = input[key].replace(/\[\[(.*?)\]\]/, '').trim();

			$.each(parsed, function (i, element){
				if (!score && !isNaN(parseInt(element, 10))) {
					score = parseFloat(element, 10);
				} else if (!options && $.inArray(element, Bulk.availableOptions) > -1) {
					buildOptions.push(element);
				}
			});

			if (!options && buildOptions.length > 0) {
				options = buildOptions;
			}
		});

		return {'index': index, 'labels' : input, 'type': type, 'score': score, 'options': (options) ? options : []};
	},

	itemFromValue: function (value) {
		return {
			text: new this.textClass({ value: (value && value.label) ? value.label : (value && value.text) ? value.text : '' })
		};
	},

	renderSubOptions: function () {
		let sub = $('<div class="suboptions" style="display: none;"></div>');
		return sub;
	},

	addItem: function (item) {
		this.value.push(item);
		this.itemAdded(item);
		return item;
	},

	itemAdded: function (item) { },

	itemChanged: function (index, value) { },

	itemsChanged: function (value) { },

	itemRemoved: function (index) { }
});

module.exports = {
	opts: {
		Value: Value,
		Button: Button,
		Text: Text,
		TextList: TextList,
		DateTime: DateTime,
		Html: Html,
		Single: Single,
		Select: Select,
		Number: Number,
		Checkbox: Checkbox,
		renderSelect: renderSelect
	}
};
